var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 219.5 303.2",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#101332;}.cls-3{fill:#08dadb;}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:#3968fe;}.cls-7{fill:url(#linear-gradient-4);}.cls-8{fill:#6a45eb;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 203.1,
    y1: 9.5,
    x2: 121,
    y2: 9.5,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 303.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#6a45eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#6a45eb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 101.55,
    y1: 0.6,
    x2: 101.55,
    y2: 159.7,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 303.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#08dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#08dadb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 134.7,
    y1: 237.1,
    x2: 134.7,
    y2: 143.59,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 303.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6a45eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#6a45eb",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 203.1,
    y1: 293.7,
    x2: 121,
    y2: 293.7,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 303.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#08dadb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#08dadb",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.9,295.2a11.52,11.52,0,0,0,3.2,8H151.7a146.61,146.61,0,0,1-14.8-.7,1.7,1.7,0,0,1-.7-.1,150.79,150.79,0,0,1-15-2.3h-.1l2.4-15.9a138.43,138.43,0,0,0,15.9,2.4c4.1.4,8.2.6,12.4.6h51.4A11.18,11.18,0,0,0,199.9,295.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M211.5,254.2h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 211.5,
    cy: 262.2,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.1,254.1H151.7c-2.5,0-5-.1-7.4-.3a102.57,102.57,0,0,1-94.8-94.3c-.2-2.6-.3-5.3-.3-8s.1-5.4.3-8H33.4c-.2,2.7-.3,5.3-.3,8s.1,5.3.3,8a141.15,141.15,0,0,0,2.1,15.9,125,125,0,0,0,6.9,22.3,131.21,131.21,0,0,0,10.9,20.2,116.21,116.21,0,0,0,14.5,17.5,121.4,121.4,0,0,0,17.5,14.5A118.55,118.55,0,0,0,126,267.3l-2.6,16.9C64.7,271.7,19.9,221.1,16.3,159.6c-.1-2.6-.2-5.3-.2-8s.1-5.4.2-8H.2c-.1,2.7-.2,5.3-.2,8s.1,5.3.2,8q.15,3.75.6,7.5c.5,5.1,1.3,10.1,2.3,15.1A151.77,151.77,0,0,0,12,210.7a151.42,151.42,0,0,0,32.5,48.2,151.85,151.85,0,0,0,22.4,18.5,150.44,150.44,0,0,0,54.2,22.8h.1c5,1,10,1.8,15,2.3a1.7,1.7,0,0,1,.7.1l2.4-15.9,2.6-16.9c3.3.3,6.5.4,9.8.4h51.4a11.52,11.52,0,0,1-3.2-8A11.77,11.77,0,0,1,203.1,254.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M203.1,66.1H151.7c-1.6,0-3.2,0-4.8.1a85.83,85.83,0,0,0-12.4,1.6c-1.2.2-2.3.5-3.5.8a93.09,93.09,0,0,0-12.6,4.2,78.22,78.22,0,0,0-14.5,7.9A83.93,83.93,0,0,0,91.3,91.1a82.89,82.89,0,0,0-10.4,12.6A85.18,85.18,0,0,0,73,118.2a81.25,81.25,0,0,0-5,16.1,70.25,70.25,0,0,0-1.3,9.2,70.26,70.26,0,0,0-.4,8,71.43,71.43,0,0,0,.4,8H82.8a69.45,69.45,0,0,1,50.7-75,69.36,69.36,0,0,1,15.8-2.4h53.8a11.6,11.6,0,0,1,0-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M151.7,221h-2.4a67.71,67.71,0,0,1-15.8-2.4,69,69,0,0,1-50.7-75H49.6a102.78,102.78,0,0,1,79-91.9,103.85,103.85,0,0,1,15.8-2.4c2.5-.2,4.9-.3,7.4-.3h51.4a11.6,11.6,0,0,1,0-16H151.8c-3.3,0-6.5.1-9.8.4l-2.6-16.9L137,.6a1.7,1.7,0,0,0-.7.1,150.79,150.79,0,0,0-15,2.3h-.1a155.69,155.69,0,0,0-28.4,8.8A151.42,151.42,0,0,0,44.6,44.3,151.85,151.85,0,0,0,26.1,66.7a149.68,149.68,0,0,0-14,25.8A147.32,147.32,0,0,0,3.2,121,150.79,150.79,0,0,0,.9,136c-.3,2.5-.4,5-.6,7.5-.1,2.7-.2,5.3-.2,8s.1,5.3.2,8H66.7a92.57,92.57,0,0,0,1.3,9.2,83.35,83.35,0,0,0,5,16.1,78.22,78.22,0,0,0,7.9,14.5A97.62,97.62,0,0,0,91.3,212a82.89,82.89,0,0,0,12.6,10.4A84.22,84.22,0,0,0,131,234.5c1.2.3,2.3.6,3.5.8a84.07,84.07,0,0,0,12.4,1.6c1.6.1,3.2.1,4.8.1h51.4a11.52,11.52,0,0,1-3.2-8,11.34,11.34,0,0,1,3.2-8ZM35.5,127.7a104.8,104.8,0,0,0-2.1,15.9H16.3C19.9,82.1,64.7,31.5,123.4,19L126,35.9a113.6,113.6,0,0,0-20.5,6.5A123.16,123.16,0,0,0,85.3,53.3,110.51,110.51,0,0,0,67.8,67.8,122.23,122.23,0,0,0,53.3,85.4a115.52,115.52,0,0,0-10.9,20.2A118.2,118.2,0,0,0,35.5,127.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M203.1,0H151.7a146.61,146.61,0,0,0-14.8.7,1.7,1.7,0,0,0-.7.1,150.79,150.79,0,0,0-15,2.3h-.1L123.5,19a138.43,138.43,0,0,1,15.9-2.4c4.1-.4,8.2-.6,12.4-.6h51.4A11.52,11.52,0,0,1,200,8,10.85,10.85,0,0,1,203.1,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 211.5,
    cy: 229.1,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 211.5,
    cy: 74.1,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 211.5,
    cy: 41.1,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 211.5,
    cy: 8,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 211.5,
    cy: 295.2,
    r: 8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.54156ba1dcb76473a001731689cae1d2.svg";
export { ForwardRef as ReactComponent };